import { StatusEnum } from "@/services/dtos/user.dto";
import { useGetRegionalsQuery } from "@/services/regional";
import { useMemo } from "react";
import { ISelectOptions } from "src/@types/select";
import { UseRegionalsOptionsReturn } from "../../../types/use.regionals.types";

export function useRegionalsOptions(
  status: StatusEnum,
  perPage = 1000
): UseRegionalsOptionsReturn {
  const {
    data: regionalsData,
    refetch,
    isFetching,
    isLoading,
  } = useGetRegionalsQuery({
    search: "",
    orderBy: JSON.stringify({ name: "asc" }),
    meta: { page: 1 },
    status,
    perPage,
  });

  const options = useMemo<ISelectOptions>(() => {
    if (!regionalsData?.data) return [];
    return regionalsData.data.map((regional) => ({
      value: regional.id.toString(),
      label: regional.name,
    }));
  }, [regionalsData]);

  return { options, refetch, isFetching, isLoading };
}